import React, { useEffect, useRef } from 'react'

export const CABIN_TABS = ['Cabins', 'Deck Plan']

export default function CabinTabBar({ active, onChange }) {
  const indicatorRef = useRef(null)
  const tabRefs      = useRef([])

  useEffect(() => {
    const el  = tabRefs.current[CABIN_TABS.indexOf(active)]
    const bar = indicatorRef.current
    if (el && bar) {
      bar.style.left  = el.offsetLeft + 'px'
      bar.style.width = el.offsetWidth + 'px'
    }
  }, [active])

  return (
    <div className="sc-cabin-tabbar">
      <div className="sc-cabin-tabbar__inner">
        {CABIN_TABS.map((tab, i) => (
          <button
            key={tab}
            ref={el => tabRefs.current[i] = el}
            className={`sc-cabin-tabbar__tab ljn-label ${active === tab ? 'sc-cabin-tabbar__tab--active' : ''}`}
            onClick={() => onChange(tab)}
          >
            {tab}
          </button>
        ))}
        <div ref={indicatorRef} className="sc-cabin-tabbar__indicator" />
      </div>
    </div>
  )
}
